export default __webpack_public_path__ + "static/media/email_video_place_holder.98dd05c5.png";